import styled from "styled-components";
import { colors } from "assets";

export default c => styled(c)`
  .tooltip-div {
    display: inline-flex;
    height: 100%;
    width: 100%;
  }

  .tooltip-icon {
    color: ${colors.primary.dark};
  }

  .row-icon {
    padding-top: 0.5em;
  }

  .black-icon {
    color: "#000";
    font-size: 2em;
  }

  .red-icon {
    color: red;
    font-size: 2em;
  }

  .new-variation-title {
    font-family: Source Sans Pro;
    font-size: 1.2em;
    font-weight: bold;
    color: #222;
    margin: 12px 8px 8px 0px;
  }

  .new-variation-subtitle {
    margin: 0px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/info/general-info/style.js